export const shellyConfig = {
  common: {
    saving: "Enregistrement...",
    online: "En ligne",
    offline: "Hors ligne",
  },

  step1: {
    title: "Configuration Shelly",
    subtitle:
      "Connectez votre compte Shelly Cloud pour contrôler vos relais (serrures électriques, portails, etc.).",
    connected: "Compte connecté",
    notConnected: "Non connecté",
    credentialsInfo:
      "Retrouvez vos identifiants dans l'application Shelly : <b>Paramètres utilisateur → Clé d'autorisation Cloud</b>. Vous y verrez le <b>Server URI</b> et pourrez générer votre <b>Auth Key</b>.",
    serverUriPlaceholder: "ex. shelly-103-eu.shelly.cloud",
    serverUriHelp: "Serveur Cloud attribué à votre compte Shelly.",
    authKeyPlaceholderSaved: "•••••••• (déjà enregistrée, modification facultative)",
    authKeyPlaceholderNew: "Collez votre clé d'autorisation Cloud",
    authKeyHelpSaved: "Vous pouvez le laisser vide si vous avez déjà une clé enregistrée.",
    authKeyHelpNew:
      "Cette clé vous permet de contrôler vos appareils : gardez-la en lieu sûr.",
    testing: "Test en cours...",
    testConnection: "Tester la connexion",
    saveCredentials: "Enregistrer les identifiants",
  },

  step2: {
    title: "Sélecteur d'appareils pour cette propriété",
    subtitle:
      "Sélectionnez uniquement les relais Shelly qui concernent <b>cette propriété</b>. Ensuite, dans le PMS, vous ne verrez que ceux sélectionnés.",
    selectedCount: "{count} sélectionné(s)",
    hintCredentials:
      "Saisissez votre Server URI et votre Auth Key, puis cliquez sur <b>Tester la connexion</b> pour charger vos appareils.",
    noDevices: "Aucun appareil trouvé dans votre compte Shelly.",
    selectPlaceholder: "Sélectionner des appareils…",
    devicesSelected: "{count} appareil(s) sélectionné(s)",
    noneSelected: "Aucun appareil sélectionné",
    channels: "{count} canaux",
    saveDevices: "Enregistrer les appareils pour cette propriété",
  },

  step3: {
    title: "Contrôle et attribution (PMS)",
    subtitle:
      "Attribuez chaque relais à <b>Porte principale</b>, <b>Unité</b> ou <b>Portail</b> et définissez l'impulsion d'ouverture.",
    assignedCount: "{count} attribué(s)",
    noSavedDevices:
      "Vous n'avez pas encore d'appareils enregistrés pour cette propriété. Utilisez le <b>Sélecteur</b> ci-dessus, puis enregistrez.",
    pulseInfo:
      "<b>Ouvrir</b> envoie une impulsion au relais (il s'allume et s'éteint tout seul après les secondes configurées) : idéal pour les serrures électriques et les portails. Shelly ne génère pas de codes PIN.",
    open: "Ouvrir",
    openTooltip: "Ouvrir (impulsion)",
    turnOnTooltip: "Allumer le relais",
    turnOffTooltip: "Éteindre le relais",
    refreshTooltip: "Actualiser l'état",
    assignment: "Attribution",
    assignNone: "Non attribué",
    assignCommon: "Porte principale (partagée)",
    assignUnit: "Porte de l'appartement",
    assignGate: "Portail / Garage",
    hintNone: "Il ne sera pas contrôlé depuis le PMS.",
    hintAssigned: "Il sera lié à cette propriété pour l'ouverture à distance.",
    unitLabel: "Unité / Logement",
    selectUnit: "Sélectionnez une unité",
    unitFallback: "Unité {id}",
    selectUnitHint: "Choisissez quelle unité ce relais ouvre.",
    channelLabel: "Canal du relais",
    channelOption: "Canal {n}",
    channelHint: "Canal câblé à la serrure (appareils multi-relais).",
    pulseLabel: "Impulsion d'ouverture (secondes)",
    pulseHint: "Durée pendant laquelle le relais reste allumé à l'ouverture.",
    nameLabel: "Nom (facultatif)",
    namePlaceholder: "ex. Porte principale / Apt 101",
    nameHint: "Nom affiché dans le PMS pour cet appareil.",
    saveAssignment: "Enregistrer l'attribution",
    tip:
      "Astuce : attribuez chaque relais et cliquez sur <b>Enregistrer l'attribution</b>. Les boutons de contrôle s'activent une fois l'appareil attribué.",
  },

  toast: {
    loadDevicesFailed: "Les appareils n'ont pas pu être chargés",
    loadDevicesError: "Erreur lors du chargement des appareils",
    missingCredentials: "Vous devez saisir le Server URI et votre Auth Key Shelly.",
    connectionSuccess:
      "Connexion réussie. {count} appareil(s) trouvé(s).",
    testError: "Erreur lors du test de la connexion",
    invalidAuthKey: "Vous devez saisir une Auth Key valide (au moins 10 caractères).",
    missingServerUri: "Vous devez saisir le Server URI de votre compte Shelly.",
    credentialsSaved: "Identifiants enregistrés avec succès",
    credentialsError: "Erreur lors de l'enregistrement des identifiants",
    credentialsSaveError: "Erreur lors de l'enregistrement des identifiants : {error}",
    selectAtLeastOne:
      "Vous devez sélectionner au moins un appareil pour cette propriété.",
    devicesSaved: "Appareils enregistrés pour cette propriété",
    devicesSaveFailed: "Les appareils n'ont pas pu être enregistrés",
    saveError: "Erreur lors de l'enregistrement : {error}",
    selectUnitForApartment:
      "Sélectionnez l'unité pour les relais attribués comme « Porte de l'appartement ».",
    assignmentFailed: "L'attribution n'a pas pu être enregistrée",
    assignmentSaved: "Attribution enregistrée avec succès",
    assignmentSaveError: "Erreur lors de l'enregistrement de l'attribution : {error}",
    opOpen: "Ouverture envoyée (impulsion du relais)",
    opOn: "Relais allumé",
    opOff: "Relais éteint",
    opDone: "Action terminée",
    opFailed: "L'action n'a pas pu être terminée",
    opError: "Erreur lors de l'exécution de l'action",
  },
};
